import type { InventarioItemListFilters } from '../types/item'
import type { InventarioResponsavelListFilters } from '../types/responsavel'

export const inventarioKeys = {
  all: ['inventario'] as const,
  status: () => [...inventarioKeys.all, 'status'] as const,
  categorias: () => [...inventarioKeys.all, 'categorias'] as const,
  resumos: () => [...inventarioKeys.all, 'resumo'] as const,
  resumoPorStatus: () => [...inventarioKeys.resumos(), 'por-status'] as const,
  itens: () => [...inventarioKeys.all, 'itens'] as const,
  itemLists: () => [...inventarioKeys.itens(), 'list'] as const,
  itemList: (filters: InventarioItemListFilters) =>
    [...inventarioKeys.itemLists(), filters] as const,
  item: (id: string) => [...inventarioKeys.itens(), 'detail', id] as const,
  ocorrencias: (id: string) => [...inventarioKeys.item(id), 'ocorrencias'] as const,
  itemResponsabilidades: (id: string) => [...inventarioKeys.item(id), 'responsabilidades'] as const,
  responsaveis: () => [...inventarioKeys.all, 'responsaveis'] as const,
  responsavelList: (filters: InventarioResponsavelListFilters) =>
    [...inventarioKeys.responsaveis(), filters] as const,
  meusItens: () => [...inventarioKeys.all, 'meus-itens'] as const,
}
